<ng-template #customLoadingTemplate>
    <div class="cm-loader">
        <div class="img-wrap"><img src="assets/images/Loader.gif" alt="loader"></div>
    </div>
</ng-template>
<ngx-loading [show]="loading" [template]="customLoadingTemplate"></ngx-loading>
<router-outlet></router-outlet>
